import styled, { useTheme } from 'styled-components';
import { FaHeart } from 'react-icons/fa'; // 아이콘 추가
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../../../components/ui';
import { addCart, getCartList } from '../../../api/services/cartService';
import { setUserCartList } from '../../../redux/userCart';
import { addFavorites } from '../../../api/services/favoritesService';
import { useGuestCheck } from '../../../hooks/useGuestCheck';
import { navigateToLogin } from '../../../utils';

const ProductCardContainer = styled.div`
  display: flex;
  flex: 1;
  text-decoration: none;
  color: inherit;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px 30px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
  gap: 20px;
  justify-content: space-between;
  cursor: pointer;
  height: 100%;

  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  &:hover {
    opacity: 1;
    visibility: visible;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 12px;
    gap: 12px;
  }

  @media (max-width: 480px) {
    padding: 8px;
    gap: 8px;
  }
`;

const ProductInfoContainer = styled.div`
  flex: 1;
  display: flex;
  gap: 60px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 0;
    align-items: flex-start;
    justify-content: flex-start;
  }

  @media (max-width: 480px) {
    gap: 6px;
  }
`;

const ProductImageWrapper = styled.div`
  display: flex;
  width: 12vw;
  position: relative;
  gap: 20px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 150px;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    max-width: 100px;
  }
`;

// Parent/Child Item: 그룹(여러 size/diameter)을 가진 아이템에 표시하는 배지
const OptionBadge = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  background: ${(props) => props.theme.colors.primaryBlue};
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 12px;
  z-index: 1;
`;

const ProductImage = styled.img`
  width: 12vw;
  height: auto;
  border: 1px solid #ddd;
  object-fit: contain;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 150px;
  }

  @media (max-width: 480px) {
    max-width: 100px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

const ProductName = styled.h3`
  font-size: 0.95rem;
  font-weight: 600;
  margin: 10px 0 5px;

  @media (max-width: 768px) {
    font-size: 0.85rem;
    margin: 8px 0 4px;
  }

  @media (max-width: 480px) {
    font-size: 0.75rem;
    margin: 6px 0 3px;
  }
`;

const ProductCode = styled.span`
  display: block;
  font-size: 0.85rem;
  color: ${(props) => props.theme.colors.menuText};
  margin-bottom: 6px;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin-bottom: 4px;
  }

  @media (max-width: 480px) {
    font-size: 0.65rem;
    margin-bottom: 3px;
  }
`;

const StockInfo = styled.div`
  font-size: 0.85rem;
  color: ${(props) =>
    props.inStock
      ? props.theme.colors.primaryGreen
      : props.theme.colors.primaryRed};
  margin-bottom: 6px;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin-bottom: 4px;
  }

  @media (max-width: 480px) {
    font-size: 0.65rem;
    margin-bottom: 3px;
  }
`;

const PriceInfo = styled.div`
  font-size: 0.85rem;
  color: #777;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }

  @media (max-width: 480px) {
    font-size: 0.65rem;
  }
`;

const UnitPrice = styled.div`
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 8px;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-bottom: 6px;
  }
`;

const AddToCartButton = styled.button`
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #2b2370;
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 8px;
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
    padding: 6px;
  }
`;

const HoverButtons = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  gap: 8px;
  opacity: 0;
  visibility: hidden;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;

  ${ProductImageWrapper}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

const IconButton = styled.button`
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 1);
  }
`;

export default function ProductItem({ data, style }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const { isGuestUser } = useGuestCheck();

  const {
    idStyle,
    webTitle,
    websitename,
    Tfilepath1,
    avaQty,
    price,
    retailPrice,
    image,
    color,
    qtyPerUOM,
    childCount,
    groupName,
  } = data;
  // 그룹 대표 항목은 그룹명을, 그룹 멤버 항목은 원래 상품명을 표시
  const displayName =
    data.isGroupCard && childCount > 1 && groupName
      ? groupName
      : websitename || webTitle;
  const imgUrl = image
    ? image
    : `${process.env.REACT_APP_FILE_UPLOAD_URL}${Tfilepath1}`;
  const inStock = avaQty > 0;

  const getDbCartList = async () => {
    if (userInfo.zipcode) {
      const result = await getCartList(
        userInfo.idCustomer,
        userInfo.zipcode,
        userInfo.idStore,
      );
      dispatch(setUserCartList({ cart_list: result.cartList }));
    }
  };

  const handleAddToCart = async (e) => {
    e.stopPropagation();

    const result = await addCart(
      userInfo.idCustomer,
      idStyle,
      color,
      qtyPerUOM,
    );
    if (result.is_success) {
      getDbCartList();
      alert(`${websitename || webTitle} added to cart!`);
    } else {
      alert(`Error while add to cart`);
    }
  };

  const handleFavorites = async () => {
    if (userInfo.userId == 0) {
      navigateToLogin(navigate, `/product?id=${idStyle}`);
      return;
    }

    const result = await addFavorites(
      userInfo.idCustomer,
      idStyle,
      color,
      qtyPerUOM,
    );
    if (result.is_success) {
      alert(`Added to favorites: ${websitename || webTitle}`);
    } else {
      alert(`Error while add to Favorites`);
    }
  };

  return (
    <ProductCardContainer
      onClick={() => {
        if (userInfo.userId != 0) {
          navigate(`/product?id=${idStyle}`);
        } else {
          navigateToLogin(navigate, `/product?id=${idStyle}`);
        }
      }}
      style={style}
    >
      <ProductInfoContainer>
        <ProductImageWrapper>
          {childCount > 1 && data.isGroupCard && (
            <OptionBadge>{`${childCount} sizes`}</OptionBadge>
          )}
          <ProductImage src={imgUrl} alt={`${websitename || webTitle}`} />
          <HoverButtons className='hover-buttons'>
            <IconButton onClick={handleFavorites}>
              <FaHeart size={16} color={theme.colors.primaryRed} />
            </IconButton>
          </HoverButtons>
        </ProductImageWrapper>
        <Column
          style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}
        >
          <ProductName>{displayName}</ProductName>
          <ProductCode>{idStyle}</ProductCode>
          <StockInfo inStock={inStock}>
            {inStock ? 'In stock' : 'Out of stock'}
          </StockInfo>
          {userInfo.userId != 0 ? (
            <>
              <PriceInfo style={{ marginTop: '30px' }}>
                SRP Price: $
                {retailPrice != null
                  ? Number(retailPrice).toFixed(2)
                  : price != null
                    ? Number(price).toFixed(2)
                    : '0.00'}{' '}
                / UNIT
              </PriceInfo>
              {!isGuestUser && price != null && (
                <UnitPrice style={{ marginTop: '10px' }}>
                  ${Number(price).toFixed(2)} / UNIT
                </UnitPrice>
              )}
              {isGuestUser ? (
                <AddToCartButton disabled style={{ opacity: 0.5 }}>
                  GUEST - CART DISABLED
                </AddToCartButton>
              ) : (
                <AddToCartButton onClick={handleAddToCart}>
                  ADD TO CART
                </AddToCartButton>
              )}
            </>
          ) : (
            <Button
              style={{ marginTop: '20px' }}
              onClick={(e) => {
                e.stopPropagation();
                navigateToLogin(navigate, `/product?id=${idStyle}`);
              }}
            >
              Login to see price
            </Button>
          )}
        </Column>
      </ProductInfoContainer>
    </ProductCardContainer>
  );
}
